import { FullScreenLoader } from "@repo/app-shell"
import { api } from "@repo/db"
import { createFileRoute, redirect } from "@tanstack/react-router"

import { convexClient, queryWithTimeout } from "@/lib/convex"

export const Route = createFileRoute("/")({
  validateSearch: (search: Record<string, unknown>) => ({
    redirect: (search.redirect as string) || undefined,
  }),
  beforeLoad: async ({ search }) => {
    const user = await queryWithTimeout(convexClient.query(api.auth.getCurrentUser))
    if (!user) {
      throw redirect({
        to: "/login",
        search: { redirect: search.redirect },
      })
    }
    if (!user.name || !user.email) {
      throw redirect({ to: "/complete-profile" })
    }
    if (search.redirect) {
      // Arbitrary path — fall through to FullScreenLoader while browser navigates
      window.location.href = search.redirect
      return
    }
    if (user.isSuperAdmin) {
      throw redirect({ to: "/check-dealership" })
    }
    if (user.isDemo && !user.dealership) {
      throw redirect({ to: "/demo" })
    }
    if (!user.dealership) {
      throw redirect({ to: "/create-dealership" })
    }
    throw redirect({
      to: "/$dealership/dashboard",
      params: { dealership: user.dealership.slug },
    })
  },
  component: FullScreenLoader,
})
